import styles from './lib/TextBox.css?inline';
import { customElement } from 'solid-element';
import { TextBox } from './lib/TextBox';
import { version } from '../package.json';
import { setComponentVersion } from '@formbird/solid-utils';
import { mandatoryStyles } from '@formbird/solid-shared';

const TextBoxWithStyles = (props: any, { element }: { element: HTMLElement }) => {
  setComponentVersion(element, version);
  return (
    <>
      <style>{styles + mandatoryStyles}</style>
      <TextBox {...props} />
    </>
  );
};

// Register the custom element
customElement('solid-text-box', {
  document: undefined,
  template: undefined,
  componentDefinition: undefined,
  fieldValue: '',
  fieldName: '',
  previousFieldValue: '',
  key: 0,
  formParameters: undefined,
}, TextBoxWithStyles);

// Export the component for testing
export { TextBox };
